export function signatureImagePath ({ id, imageVersion }) {
  const versionQuery = imageVersion ? `?v=${imageVersion}` : ''
  return `${RELATIVE_URL_ROOT}signature_images/${id}.png${versionQuery}`
}

export function redirectTo (path = '', params = {}) {
  window.location = buildPath(path, params)
}

export function builderPath (documentId) {
  return buildPath(`builder/${documentId}`)
}

export function templateBuilderPath (templateId) {
  return buildPath(`template_builder/${templateId}`)
}

export function finishTemplatePath (templateId) {
  return buildPath(`templates/${templateId}/finish`)
}

export function useTemplatePath (templateId) {
  return buildPath(`templates/${templateId}/use`)
}

export function updateUserPath (userId) {
  return buildPath(`users/${userId}`)
}

export function documentPdfPath (documentId, downloadFormat = '.pdf') {
  return `${RELATIVE_URL_ROOT}documents/${documentId + downloadFormat}`
}

export function printDocumentPath (documentId) {
  return buildPath(`documents/${documentId}/print`)
}

export function downloadDocumentPath (documentId) {
  return buildPath(`documents/${documentId}/download`)
}

export function embeddedDocumentPdfPath (documentId, downloadFormat = '.pdf') {
  return `${RELATIVE_URL_ROOT}embedded_documents/${documentId + downloadFormat}`
}

export function documentAuditPdfPath (auditId) {
  return `${RELATIVE_URL_ROOT}completed_documents/audit/${auditId}.pdf`
}

export function sharedDocumentPdfPath (token) {
  return `${RELATIVE_URL_ROOT}docs/${token}.pdf`
}

export function savedSharedDocumentPdfPath (token) {
  return `${RELATIVE_URL_ROOT}docs/saved/${token}.pdf`
}

export function documentContactsPath (documentId, params = {}) {
  return buildPath(`documents/${documentId}/contacts`, params)
}

export function embeddedDocumentContactsPath (documentEmbeddingToken, params = {}) {
  return buildPath(`edit/document/${documentEmbeddingToken}/contacts?signwell_embedded_iframe=1`, params)
}

export function templatePlaceholdersPath (templateId) {
  return buildPath(`templates/${templateId}/placeholders`)
}

export function embeddedTemplatePlaceholdersPath (templateEmbeddingToken, params = {}) {
  return buildPath(`edit/template/${templateEmbeddingToken}/placeholders?signwell_embedded_iframe=1`, params)
}

export function signInPersonCreateDocumentPath (templateId) {
  return buildPath(`sign_in_person/${templateId}/create_document`)
}

export function signInPersonAssignContactPath (documentId) {
  return buildPath(`sign_in_person/${documentId}/assign_contact`)
}

export function signInPersonPlaceholderSelectPath (documentId) {
  return buildPath(`sign_in_person/${documentId}`)
}

export function createTeamPath () {
  return `${RELATIVE_URL_ROOT}teams/`
}

export function updateTeamPath (teamId) {
  return buildPath(`teams/${teamId}`)
}

export function destroyTeamPath (teamId) {
  return buildPath(`teams/${teamId}`)
}

export function buildPath (path = '', params = {}) {
  const uri = RELATIVE_URL_ROOT + path
  const query = Object.entries(params)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&')

  let builtPath = uri.replace(/\/+$/, '/')
  if (query.length > 0) {
    builtPath = `${builtPath}?${query}`
  }
  return builtPath
}
